import * as React from 'react'
import { Tooltip, Icon, Menu, Dropdown } from 'antd'
import { withRouter, RouteComponentProps } from "react-router-dom"
import { withIdentity, IdentityProps } from "../services/authentication"
import { withTranslation, WithTranslation } from 'react-i18next'
import Link from './link'
import LoginBox from './login-box'
import LanguageBox from './language-box'
import HelpDesk from './help-desk'
import windowSize from 'react-window-size'
import { withSize } from 'react-sizeme'
import autobind from 'autobind-decorator'
import MyAppsView from './my-apps'

export interface NavItemProps {
  title: string | React.ReactNode,
  to?: string
  target?: string
  icon?: string | React.ReactNode,
  subMenu: Menu,
  iconOnly?: boolean
  selected?: boolean
}

function WrapInDropdown(props: any) {
  if (props.subMenu) {
    return <Dropdown overlay={props.subMenu} trigger={['click']}>
      {(() => {
        if (props.to) {
          return <Link to={props.to || ''} className="ant-dropdown-link" style={{ height: 44 }}>
            {props.children}
          </Link>
        }
        return <div className="ant-dropdown-link" style={{ height: 44 }}>{props.children}</div>
      })()}
    </Dropdown>
  }

  if (props.to) {
    if (props.target)
      return <a href={props.to || ''} target={props.target} >
        {props.children}
      </a>
    return <Link to={props.to}>{props.children}</Link>
  }
  return props.children
}

class NavItemClass extends React.Component<NavItemProps> {
  public render() {
    var width = (this.props as any).windowWidth
    var isMobileOrTable = width < 768
    let icon: React.ReactNode = undefined
    let title: React.ReactNode = undefined
    let iconOnly = this.props.iconOnly && !isMobileOrTable
    if (this.props.icon) {
      if (typeof this.props.icon === 'string') {
        icon = <Icon type={this.props.icon as string} />
      } else {
        icon = this.props.icon
      }
    }
    if (typeof this.props.title === 'string') {
      title = <span>{this.props.title}</span>
    } else {
      title = this.props.title
    }
    if (this.props.subMenu && isMobileOrTable) {
      return <div className='navbar-items'>
        <div className={`navbar-item${this.props.selected ? ' selected' : ''}`}>
          {icon && <div style={{ float: 'left' }}>
            <Tooltip title={iconOnly && typeof this.props.title === 'string' ? this.props.title : ''} placement='bottom'>
              {icon}
            </Tooltip>
          </div>}
          {!iconOnly && title}
        </div>
        {this.props.subMenu}
      </div>
    }
    return <div className={`navbar-item${this.props.selected ? ' selected' : ''}`}>
      <WrapInDropdown subMenu={this.props.subMenu} to={this.props.to} target={this.props.target}>
        {icon && <div style={{ float: 'left' }}>
          <Tooltip title={iconOnly && typeof this.props.title === 'string' ? this.props.title : ''} placement='bottom'>
            {icon}
          </Tooltip>
        </div>}
        {!iconOnly && title}
      </WrapInDropdown>
    </div>
  }
}
export const NavItem = windowSize(NavItemClass as any) as any

interface ShellHeaderProps extends IdentityProps, WithTranslation, RouteComponentProps {
  prefix?: string,
  getTopMainMenu?: (t: (value: string) => string, isMobile: boolean) => React.ReactNode[],
  getTopRightMenu?: (t: (value: string) => string, isMobile: boolean) => React.ReactNode[],
  logo?: any,
  ensureCompanySelection?: boolean
  languages?: string[]
  hideHelpdesk?: boolean
  hideMyApps?: boolean
  logoWidth?: string
}

interface ShellHeaderState {
  collapsed: boolean
  onAppShowns: boolean
  logoWitdh: string
}

class ShellHeader extends React.Component<ShellHeaderProps, ShellHeaderState> {

  public constructor(props: ShellHeaderProps) {
    super(props)
    this.state = {
      collapsed: true,
      onAppShowns: false,
      logoWitdh: this.props.logoWidth ?? "80px"
    }
  }

  @autobind
  public handleHamburger() {
    this.setState({ collapsed: !this.state.collapsed })
  }

  @autobind
  public someMenuClicked(e: any) {
    if (!this.state.collapsed) {
      setTimeout(() => this.setState({ collapsed: true }), 100)
    }
  }

  public render() {
    const { t } = this.props
    var width = (this.props as any).size.width
    var isMobileOrTablet = (width <= 768)
    var parts = this.props.location.pathname.split('/').filter(o => o != '')
    const firstPath = `/${parts.length > 0 ? parts[0] : this.props.prefix ? this.props.prefix : ""}`
    var role = this.props.identity && this.props.identity.roles && this.props.identity.roles.length > 0 && this.props.identity.roles[0]
    var topMainMenu = this.props.getTopMainMenu ? this.props.getTopMainMenu(t, width) : []
    var topRightMenu = this.props.getTopRightMenu ? this.props.getTopRightMenu(t, width) : []
    return <div className="navbar" onClickCapture={this.someMenuClicked}>
      <nav className="navbar-items navbar-items-left">
        <NavItem
          key="/"
          to="/"
          title={
            <>
              <div style={{ display: "flex" }}>
                <div className={"logo-image-container"} style={{ width: this.state.logoWitdh, transition: "all 0.2s", textAlign: 'center' }}>
                  <img src={this.props.logo} height={24} />
                </div>
                <div className={"logo-border"}></div>
                <span id="logo-text">Helping ideas grow</span>
              </div>
            </>
          } />
        {isMobileOrTablet && <div className="navbar-item navbar-item-toggle" onClick={this.handleHamburger}>
          <div></div>
          <div></div>
          <div></div>
        </div>}
        {(!this.state.collapsed || !isMobileOrTablet) && topMainMenu}
      </nav>
      {(!this.state.collapsed || !isMobileOrTablet) && <nav className="navbar-items navbar-items-right">
        {topRightMenu}
        <LanguageBox isMobileOrTablet={isMobileOrTablet} languages={this.props.languages} />
        {!this.props.hideHelpdesk && < HelpDesk isMobileOrTablet={isMobileOrTablet} />}
        {!this.props.hideMyApps &&
          <div
            className={`navbar-item`}
            onClick={() => {

              this.setState({ onAppShowns: true })

            }}
          >
            <a style={{ display: 'inline-block' }}>
              <div style={{ float: 'left' }}>
                <Icon type="appstore"
                  style={{
                    fontSize: '35px',
                    marginTop: '12px',
                    marginLeft: '4px',
                    marginRight: '4px',
                    color: '#0000A9',
                    width: '35px',
                    background: 'white',
                  }}
                />
              </div>
              <span style={{ marginLeft: '0px' }}>{t('My Apps')}</span>
            </a>
          </div>
        }
        <LoginBox isMobileOrTablet={isMobileOrTablet} ensureCompanySelection={this.props.ensureCompanySelection} />

      </nav>}
      <MyAppsView
        visible={this.state.onAppShowns}
        onClose={() => {
          this.setState({ onAppShowns: false })
        }}
      ></MyAppsView>
    </div>

    //<Row>
    //    <Col span={16}>
    //        <Link to='/'>
    //            <img src={this.props.logo} style={{ float: 'left', marginTop: 10, marginLeft: 10 }} height={35} /> 
    //        </Link>
    //        <Menu
    //            theme="dark"
    //            mode="horizontal"
    //            defaultSelectedKeys={[firstPath]}
    //            className="header-menu">
    //            {topMainMenu}
    //            {/*<Menu.Item key='/home'><Link to='/'>Portal</Link></Menu.Item>
    //            {(role == 'User' || role == 'Consultor' || role == 'Manager' || role == 'Administrator') && <Menu.Item key='/extranet'><Link to='/extranet'>Extranet</Link></Menu.Item>}
    //            {(role == 'Consultor' || role == 'Manager' || role == 'Administrator') && <Menu.Item key='/rndplatform'><Link to='/rndplatform'>R&D Platform</Link></Menu.Item>}
    //            {(role == 'Administrator') && <Menu.Item key='/identity/admin'><Link to='/identity/admin'>Identity</Link></Menu.Item>}*/}
    //        </Menu>
    //    </Col>
    //    <Col span={8}>
    //        <Menu
    //            className={`header-menu right-menu${isMobileOrTablet ? ' right-menu-collapsed' : ''}`}
    //            theme="dark"
    //            mode="horizontal"
    //            defaultSelectedKeys={[firstPath]}
    //            style={{ lineHeight: '56px', minHeight: 56, textAlign: 'right' }}>
    //            <Menu.Item><LoginBox isMobileOrTablet={isMobileOrTablet} ensureCompanySelection={this.props.ensureCompanySelection} /></Menu.Item>
    //            <Menu.Item><LanguageBox isMobileOrTablet={isMobileOrTablet} /></Menu.Item>
    //            {topRightMenu}
    //        </Menu>
    //    </Col>
    //</Row>
  }
}
export default withTranslation()(withSize()(withRouter(withIdentity(ShellHeader))) as any) as any